export const FETCH_UPLOAD_PROGRESS_BAR_REQUEST = 'FETCH_UPLOAD_PROGRESS_BAR_REQUEST'
export const FETCH_UPLOAD_PROGRESS_BAR_SUCCESS = 'FETCH_UPLOAD_PROGRESS_BAR_SUCCESS'
export const FETCH_UPLOAD_PROGRESS_BAR_FALUIRE = 'FETCH_UPLOAD_PROGRESS_BAR_FALUIRE'
